import { render } from "./colorcard.vue?vue&type=template&id=5f1d1a94&scoped=true"
import script from "./colorcard.vue?vue&type=script&lang=js"
export * from "./colorcard.vue?vue&type=script&lang=js"

import "./colorcard.vue?vue&type=style&index=0&id=5f1d1a94&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\86183\\Desktop\\yw-admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f1d1a94"]])

export default __exports__